export default {
  PaletteFooter: {
    backgroundColor: "white",
    height: "5vh",
    display: "flex",
    justifyContent: "flex-end",
    fontWeight: "bold",
    alignItems: "center",
  },
  emoji: {
    fontSize: "1rem",
    margin: "0 0.5rem",
  },
};
